import { ACTIVITY_REQUEST, ACTIVITIES_SHOW, ACTIVITIES_LIST, ACTIVITY_EDIT, ACTIVITY_VERIFICATION_MEDIA,ACTIVITY_COMPLETE, ACTIVITY_CLEAR, ACTIVITY_FAIL} from "../store/config";

const activityInit = {
	isFetching: false,
	list: [],
	pages: {
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	filters:{
		q:''
	},
	edit: {},
	permissions: [],
	error: null,
	message: null
};

const activities = (state = activityInit,action) => {
	switch (action.type){
		case ACTIVITY_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case ACTIVITIES_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case ACTIVITIES_LIST:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				timestamp: action.timestamp
			}
		case ACTIVITY_EDIT:
			return {
				...state,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case ACTIVITY_VERIFICATION_MEDIA:
			return {
				...state,
				edit: {
					...state.edit,
					...action.payload
				},
				timestamp: action.timestamp
			}
		case ACTIVITY_COMPLETE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case ACTIVITY_CLEAR:
			return {
				...state,
				edit: action.payload,
				timestamp: action.timestamp
			}
		case ACTIVITY_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return{
				...state
			}
	}
};

export default activities;


// WEBPACK FOOTER //
// ./src/reducers/activities.js